<template>
  <section class="contact-us" id="contact-us">
    <div class="container">
      <!-- Title  -->
      <h1 class="title">Contattaci</h1>

      <!-- Text  -->
      <p class="paragraph">
        Ci puoi contattare ai seguenti contatti per richiedere assistenza
        tecnica o per prenotare un sopralluogo per un'installazione, per
        facilitare e velocizzare i tempi di intervento e di reperimento ricambi,
        si prega di inviare tramite whatsapp o email modello e matricola
        dell'unità interna ed esterna solitamente posizionati nell'etichetta a
        lato/sotto dell'unità.
      </p>

      <!-- Label Image -->
      <div id="label-img" class="label-position">
        <img
          v-if="labels[activeLabelIndex].available"
          :src="labelPath"
          @click="openImg"
          alt="posizione etichetta"
        />

        <!-- Not available img  -->
        <div v-else class="not-available">
          IMMAGINE NON DISPONIBILE
        </div>
      </div>

      <!-- Full Screen Image  -->
      <div
        class="full-screen-img"
        :class="{
          'd-none': !isImgOpen,
          'd-flex justify-content-center align-items-center': isImgOpen,
        }"
      >
        <!-- Close Btn  -->
        <div class="close-img-btn position-absolute" @click="closeImg">
          <i class="fas fa-times"></i>
        </div>

        <!-- Image  -->
        <div class="image-container">
          <img :src="labelPath" alt="posizione etichetta" />
        </div>
      </div>

      <!-- Image DESC  -->
      <p class="paragraph img-desc">
        Esempio di etichetta con modello e matricola.
      </p>

      <!-- Brand label SELECTION  -->
      <div class="brand-selection d-lg-flex justify-content-between">

        <!-- From PC  -->
        <div
          class="label-button d-none d-lg-flex flex-column justify-content-center align-items-center"
          :class="{ checked: activeLabelIndex === i }"
          v-for="(label, i) in labels"
          :key="i"
        >
          <!-- Radio Button  -->
          <div class="radio-button mr-2" @click="setActiveLabel(i)"></div>

          <!-- Button Label  -->
          <div class="button-label">
            {{ label.brand }}
          </div>
        </div>

        <!-- From Mobile  -->
        <div id="mobile-selection" class="label-button d-lg-none">
          <div
            class="select-button"
            :class="{ 'opened-selection': isMobileSelectionOpen }"
            @click="openMobileSelection()"
          >
            <!-- Button Text  -->
            <div class="button-txt" @click="scrollInView('label-img')">
              {{brandLabelText}}
              <span
                class="chevron-down"
                :class="{ 'mb-2': isMobileSelectionOpen }"
              >
                <i class="fas fa-chevron-down"></i>
              </span>
            </div>

            <!-- Selection  -->
            <div
              class="brand-option d-flex align-items-center justify-content-center"
              :class="{ visible: isMobileSelectionOpen }"
              @click="setActiveLabel(i)"
              v-for="(label, i) in labels"
              :key="i"
            >
              {{ label.brand }}
            </div>
          </div>
        </div>
      </div>

      <!-- Contacts  -->
      <ul
        class="contacts row row-cols-2 row-cols-lg-4 justify-content-center mb-4 mt-4"
      >
        <!-- Single contact -->
        <li class="contact col">
          <a href="tel:3319929042">
            <div class="icon">
              <i class="fa-solid fa-mobile"></i>
            </div>

            <p class="paragraph contact-type">Cellulare</p>

            <p class="paragraph">+39 3319929042</p>
          </a>
        </li>

        <!-- Single contact -->
        <li class="contact col">
          <a href="tel:0721977049">
            <div class="icon">
              <i class="fa-solid fa-phone"></i>
            </div>

            <p class="paragraph contact-type">Telefono fisso</p>

            <p class="paragraph">+39 0721977049</p>
          </a>
        </li>

        <!-- Single contact -->
        <li class="contact col">
          <a href="mailto: info@climacool.it">
            <div class="icon">
              <i class="fa-solid fa-envelope"></i>
            </div>

            <p class="paragraph contact-type">E-mail</p>

            <p class="paragraph">info@climacool.it</p>
          </a>
        </li>

        <!-- Single contact -->
        <li class="contact col">
          <a href="https://wa.me/3319929042" target="/blank">
            <div class="icon">
              <i class="fa-brands fa-whatsapp"></i>
            </div>

            <p class="paragraph contact-type">Whatsapp</p>

            <p class="paragraph">+39 3319929042</p>
          </a>
        </li>
      </ul>

      <!-- Position  -->
      <div class="our-location d-flex justify-content-center">
        <iframe
          title="maps"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2882.4091196515856!2d13.113934075662172!3d43.743600346580095!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x132d0c5ad7d4f3cd%3A0x4dd2c27298bf23f0!2sVia%20Enrico%20Mattei%2C%2061037%20Mondolfo%20PU!5e0!3m2!1sit!2sit!4v1737219779750!5m2!1sit!2sit"
          width="800"
          height="400"
          style="border: 0"
          allowfullscreen=""
          loading="lazy"
          referrerpolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: "ContactUs",
  data: function () {
    return {
      labels: [
        {
          brand: "LG",
          available: false,
        },
        {
          brand: "Mitsubishi",
          available: true,
        },
        {
          brand: "Samsung",
          available: false,
        },
        {
          brand: "Hisense",
          available: false,
        },
        {
          brand: "Olimpia splendid",
          available: false,
        },
        {
          brand: "Midea",
          available: false,
        },
        {
          brand: "FantiniCosmi",
          available: false,
        },
      ],
      activeLabelIndex: 1,
      isMobileSelectionOpen: false,
      isImgOpen: false,
      labelSelectionDefault: true,
    };
  },
  methods: {
    setActiveLabel: function (labelIndex) {
      this.labelSelectionDefault = false;
      this.activeLabelIndex = labelIndex;
      if (this.isMobileSelectionOpen) {
        this.scrollInView('label-img');
      } 
    },
    openMobileSelection: function () {
      this.isMobileSelectionOpen = !this.isMobileSelectionOpen; 
  	  this.scrollInView('mobile-selection');
    },
    scrollInView: function(elementToView) {

      // If it needs to scroll to the selection check if it exist and do it 
      const mobileSelection = document.getElementById('mobile-selection');

      if (elementToView === 'mobile-selection' && mobileSelection) {
        // Uses scroll-margin-bottom to center the element 
        mobileSelection.scrollIntoView({behavior: "smooth", block: "center"});

        // Alternative 
        // let yOffset = 50;
        // const y = mobileSelection.getBoundingClientRect().top + window.pageYOffset - yOffset;
        // window.scrollTo({top: y, behavior: "smooth"})
        return;
      }

      if (this.isMobileSelectionOpen) {
        // If it needs to scroll to the image 
        const labelImg = document.getElementById('label-img');
        labelImg.scrollIntoView({behavior: "smooth", block: "center"});
        mobileSelection.id = "";
        
        // Re-add the id to the element after the open mobile selection method is executed so it cannot scroll 
        setTimeout(() => {
          mobileSelection.id = 'mobile-selection';
        }, 500);
      }

    },
    openImg: function () {
      this.isImgOpen = true;
    },
    closeImg: function () {
      this.isImgOpen = false;
    },
  },
  computed: {
    labelPath() {
      if (!this.labels[this.activeLabelIndex].available) {
        return "";
      }
      return require(`../assets/images/modello-${this.labels[this.activeLabelIndex].brand.toLowerCase()}.jpg`);
    },
    brandLabelText() {
      if (this.labelSelectionDefault) {
        return "Seleziona il marchio";
      }
      return this.labels[this.activeLabelIndex].brand;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../styles/variables.scss";

.contact-us {
  background-color: $back_color;

  .container {
    // Title
    .title {
      color: $brand_primary_color;
      font-weight: bold;
    }

    // Label
    .label-position {
      width: 30%;
      margin: auto;
      margin-bottom: 1.4rem;
      margin-top: 3.8rem;
      aspect-ratio: 18 / 10;
      overflow: hidden;
      width: 50%;

      @media screen and (min-width: 992px) {
        width: 30%;
      }
      
      .not-available {
        background: rgb(0, 0, 0);
        color: $brand_primary_color;
        font-weight: bold;
        display: flex;
        text-align: center;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

      }
    }

    // Full screen img
    .full-screen-img {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: rgba($color: #141318, $alpha: 0.9);
      z-index: 10;

      .close-img-btn {
        color: white;
        top: 5%;
        right: 5%;
        font-size: 2.2rem;
      }

      .image-container {
        width: 80vw;
      }
    }

    .img-desc {
      margin-bottom: 60px;
      font-size: 14px;
    }

    // Brand label selection
    .brand-selection {
      text-align: center;
      margin: auto;

      @media screen and(min-width: 992px) {
        width: 70%;
      }

      // From PC
      .label-button {

        .radio-button {
          width: 22px;
          height: 22px;
          border-radius: 50%;
          background-color: black;
          position: relative;
          transition: all 0.5s;

          &::after {
            content: "";
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: white;
            transition: all 0.5s;
          }
        }

        &.checked {
          .radio-button {
            background-color: $brand_primary_color;

            &::after {
              width: 12px;
              height: 12px;
            }
          }
        }
      }

      // From Mobile
      #mobile-selection {
        scroll-margin-bottom: 22rem;
      }

      .select-button {
        border: 4px solid $brand_primary_color;
        border-radius: 10px;
        font-weight: bold;
        width: clamp(70%, 45%, 40%);
        min-width: 180px;
        max-width: 320px;
        margin: auto;
        transition: all 0.5s;

        &.opened-selection {
          width: 70vw;
          height: 500px;
        }

        .button-txt {
          padding: 0.85em 0;
          .chevron-down {
            display: inline-block;
          }
        }

        .brand-option {
          font-weight: bold;
          text-align: center;
          opacity: 0;
          transition: all 0.5s;
          height: 0px;
          overflow: hidden;

          &.visible {
            opacity: 1;
            height: 60px;
          }
        }
      }
    }

    // Contacts
    .contacts {
      // Single contact
      .contact {
        margin: 3.8rem 0;

        @media screen and (min-width: 992px) {
             margin: 5rem 0;
        }

        a:hover {
          color: $brand_primary_color;
          transition: all 0.5s;
        }

        // Icon
        .icon {
          text-align: center;
          font-size: 1.6rem;
        }

        // Type of contact
        .contact-type {
          font-weight: bold;
        }

        p {
          margin-bottom: 0;
        }
      }
    }

    // Our location
    .our-location {
      width: 100%;
    }
  }
}
</style>
